import { type Role } from "@vidario/domain";

import { useAuth } from "../providers/auth-provider";

/** Typed accessor for the signed-in user's role. Returns `null` when no
 * user is loaded (either unauthenticated or the profile is still fetching). */
export function useRole(): Role | null {
  const { user } = useAuth();
  return user?.role ?? null;
}

/** Narrow guard: `true` iff the signed-in user is an admin. */
export function useIsAdmin(): boolean {
  return useRole() === "admin";
}
